// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-root {
  display: flex;
  width: 100%;
  height: 100vh;
}

.login-img-panel {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.login-img-container {
  width: 100%;
  height: 100%;
}

.login-img-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 36px;
  width: 100%;
}

.login-img-txt-1.MuiTypography-root {
  color: #f9f9f9;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.login-img-txt-2.MuiTypography-root {
  color: #f9f9f9;
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: -0.336px;
}

.login-content {
  width: 50%;
}

.login-header {
  display: flex;
  justify-content: space-between;
  height: 10vh;
  margin: 52px 83px;
}

.header-boxpay-logo {
  height: 50px;
  width: 80px;
}

.login-main-form {
  margin: 52px 120px 40px 83px;
}

.login-main-title1.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.384px;
}

.login-main-title2.MuiTypography-root {
  color: #547187;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  /* 155.556% */
  letter-spacing: -0.216px;
}

.email-error {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 4px;
  min-height: 46px;
  gap: 4px;
}

.labelRegularRes.MuiTypography-root {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.back-to-login {
  color: var(--generic-primary-accent, #403e9f);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.back-to-login:hover {
  cursor: pointer;
}

.txt-field.MuiInputBase-root {
  height: 50px !important;
}

.helper-text {
  display: flex;
  justify-content: space-between;
  min-height: 46px;
}

@media only screen and (max-width: 1000px) {
  .login-root {
    flex-direction: column;
  }

  .login-img-panel {
    height: 40vh;
    width: 100%;
  }

  .login-content {
    width: 100%;
  }

  .login-header {
    height: 10vh;
    margin: 0px;
    padding: 16px 20px 16px 20px;
  }

  .login-img-text-container {
    height: 32px;
  }

  .login-img-txt-1.MuiTypography-root {
    font-size: 12px;
    line-height: 14px;
  }

  .login-img-txt-2.MuiTypography-root {
    font-size: 18px;
    line-height: 22px;
  }

  .login-img-text-container {
    margin-top: 20px;
  }

  .login-img-container {
    height: 68%;
  }

  .header-boxpay-logo {
    height: 38px;
    width: 61px;
  }

  .login-main-form {
    margin: 0px;
    padding: 23px 20px 23px 20px;
  }

  .login-main-title1.MuiTypography-root {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.24px;
  }

  .login-main-title2.MuiTypography-root {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .labelRegularRes.MuiTypography-root {
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }

  .back-to-login {
    font-size: 12px;
    line-height: 14px;
  }

  .resend-text.MuiTypography-root {
    font-size: 12px;
    line-height: 14px;
  }

  .resend-text-time.MuiTypography-root {
    font-size: 12px;
    line-height: 14px;
  }

  .resend-otp.MuiTypography-root {
    font-size: 12px;
  }

  .infoDescription {
    font-size: 10px;
    line-height: 13px;
  }

  .email-error {
    min-height: 36px;
  }
}

.bodyB2Regular {
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.resend-text.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.resend-text-time.MuiTypography-root {
  color: var(--generic-primary-accent, #403e9f);
  font-size: 14px;
  font-weight: 500;
  font-family: Poppins;
}

.resend-otp.MuiTypography-root {
  cursor: pointer;
  color: var(--generic-primary-accent, #403e9f);
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
}

.reset-title {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.384px;
  width: 251px;
}

.infoDescription {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
  /* Label/Regular */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  /* 116.667% */
}

.alert.MuiPaper-root.MuiAlert-root {
  background-color: #feffe6;
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
  border-radius: 8px;
  z-index: 1000;
  height: 54px;
  margin-top: 24px;
  font-family: Poppins !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  padding: 2px 20px 2px 20px;
}

.inputBoxWidth.MuiInputBase-root.MuiOutlinedInput-root {
  width: 100%;
}

.textArea.MuiInputBase-root.MuiOutlinedInput-root {
  width: 100%;
}

.alert-red.MuiPaper-root.MuiAlert-root {
  border-radius: 8px;
  background: #b9232f;
  margin-top: 24px;
  color: white !important;
}

.css-1xqk0hu-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;
  background-color: rgba(0, 0, 0, 0.12) !important;
}

.css-1ytlwq5-MuiAlert-icon {
  display: none !important;
}

.validation-field {
  margin-bottom: 4px;
  font-size: 12px;
  font-family: Poppins !important;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Login/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".login-root {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n}\n\n.login-img-panel {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.login-img-container {\n  width: 100%;\n  height: 100%;\n}\n\n.login-img-text-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 36px;\n  width: 100%;\n}\n\n.login-img-txt-1.MuiTypography-root {\n  color: #f9f9f9;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n}\n\n.login-img-txt-2.MuiTypography-root {\n  color: #f9f9f9;\n  font-family: Poppins;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n  letter-spacing: -0.336px;\n}\n\n.login-content {\n  width: 50%;\n}\n\n.login-header {\n  display: flex;\n  justify-content: space-between;\n  height: 10vh;\n  margin: 52px 83px;\n}\n\n.header-boxpay-logo {\n  height: 50px;\n  width: 80px;\n}\n\n.login-main-form {\n  margin: 52px 120px 40px 83px;\n}\n\n.login-main-title1.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  font-family: Poppins;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.384px;\n}\n\n.login-main-title2.MuiTypography-root {\n  color: #547187;\n  font-family: Poppins;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  /* 155.556% */\n  letter-spacing: -0.216px;\n}\n\n.email-error {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 4px;\n  min-height: 46px;\n  gap: 4px;\n}\n\n.labelRegularRes.MuiTypography-root {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.back-to-login {\n  color: var(--generic-primary-accent, #403e9f);\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.back-to-login:hover {\n  cursor: pointer;\n}\n\n.txt-field.MuiInputBase-root {\n  height: 50px !important;\n}\n\n.helper-text {\n  display: flex;\n  justify-content: space-between;\n  min-height: 46px;\n}\n\n@media only screen and (max-width: 1000px) {\n  .login-root {\n    flex-direction: column;\n  }\n\n  .login-img-panel {\n    height: 40vh;\n    width: 100%;\n  }\n\n  .login-content {\n    width: 100%;\n  }\n\n  .login-header {\n    height: 10vh;\n    margin: 0px;\n    padding: 16px 20px 16px 20px;\n  }\n\n  .login-img-text-container {\n    height: 32px;\n  }\n\n  .login-img-txt-1.MuiTypography-root {\n    font-size: 12px;\n    line-height: 14px;\n  }\n\n  .login-img-txt-2.MuiTypography-root {\n    font-size: 18px;\n    line-height: 22px;\n  }\n\n  .login-img-text-container {\n    margin-top: 20px;\n  }\n\n  .login-img-container {\n    height: 68%;\n  }\n\n  .header-boxpay-logo {\n    height: 38px;\n    width: 61px;\n  }\n\n  .login-main-form {\n    margin: 0px;\n    padding: 23px 20px 23px 20px;\n  }\n\n  .login-main-title1.MuiTypography-root {\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: -0.24px;\n  }\n\n  .login-main-title2.MuiTypography-root {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n  }\n\n  .labelRegularRes.MuiTypography-root {\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 12px;\n  }\n\n  .back-to-login {\n    font-size: 12px;\n    line-height: 14px;\n  }\n\n  .resend-text.MuiTypography-root {\n    font-size: 12px;\n    line-height: 14px;\n  }\n\n  .resend-text-time.MuiTypography-root {\n    font-size: 12px;\n    line-height: 14px;\n  }\n\n  .resend-otp.MuiTypography-root {\n    font-size: 12px;\n  }\n\n  .infoDescription {\n    font-size: 10px;\n    line-height: 13px;\n  }\n\n  .email-error {\n    min-height: 36px;\n  }\n}\n\n.bodyB2Regular {\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.resend-text.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.resend-text-time.MuiTypography-root {\n  color: var(--generic-primary-accent, #403e9f);\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Poppins;\n}\n\n.resend-otp.MuiTypography-root {\n  cursor: pointer;\n  color: var(--generic-primary-accent, #403e9f);\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.reset-title {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  font-family: Poppins;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.384px;\n  width: 251px;\n}\n\n.infoDescription {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n  /* Label/Regular */\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  /* 116.667% */\n}\n\n.alert.MuiPaper-root.MuiAlert-root {\n  background-color: #feffe6;\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n  border-radius: 8px;\n  z-index: 1000;\n  height: 54px;\n  margin-top: 24px;\n  font-family: Poppins !important;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  padding: 2px 20px 2px 20px;\n}\n\n.inputBoxWidth.MuiInputBase-root.MuiOutlinedInput-root {\n  width: 100%;\n}\n\n.textArea.MuiInputBase-root.MuiOutlinedInput-root {\n  width: 100%;\n}\n\n.alert-red.MuiPaper-root.MuiAlert-root {\n  border-radius: 8px;\n  background: #b9232f;\n  margin-top: 24px;\n  color: white !important;\n}\n\n.css-1xqk0hu-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;\n  background-color: rgba(0, 0, 0, 0.12) !important;\n}\n\n.css-1ytlwq5-MuiAlert-icon {\n  display: none !important;\n}\n\n.validation-field {\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-family: Poppins !important;\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
